import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { gateNexusSubscription } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { map, type Observable } from 'rxjs';
import { RouteOptimizationResult } from '../entities/RouteOptimizationResult.js';

export const subscribeRoutePlanningById = registerSubscription({
  operationName: 'subscribeRoutePlanningById',
  type: () => RouteOptimizationResult,
  params: [{ name: 'routePlanningId', type: () => String }],
  resolve: (routePlanningId: string) => (_gqlFields: BaseQLSelectionSet<RouteOptimizationResult>) => {
    return gateNexusSubscription(NexusPermission.RoutePlanning, () =>
      watchQuery<RouteOptimizationResult>(
        'route-plannings',
        { _id: routePlanningId, type: 'Dell' },
        {
          limit: 1,
        },
      ).pipe(map((data: RouteOptimizationResult[]) => data[0])),
    ) as Observable<RouteOptimizationResult>;
  },
});
